export default "__VITE_ASSET__CDQ5EwhJ__"